import React from 'react';
import NormeiController from './normei-mode/NormeiController';
import UserBalances from './normei-mode/UserBalances';
import FeedPeople from './people/FeedPeople';
import DesktopGuard from '@/components/auth/desktop/DesktopGuard';
export const DSearchHome = () => {
  return (
    // <>
    //   {showWildWest ? (
    //     <DegenController />
    //   ) : (
    //     <div className='flex flex-row gap-2 p-4'>
    //       <div className='grid grid-cols-1 gap-2 w-1/3'>
    //         <UserPortfolioChart />
    //         <UserTopGainers />
    //       </div>
    //       <div className='w-2/3'>
    //         <NormeiController />
    //       </div>
    //     </div>
    //   )}
    // </>

    // Temporary solution to deactivate degen mode (only normie mode)
    <div className='flex flex-row gap-2 p-4' data-sentry-component="DSearchHome" data-sentry-source-file="DSearchHome.tsx">
      <div className='w-2/3'>
        <NormeiController data-sentry-element="NormeiController" data-sentry-source-file="DSearchHome.tsx" />
      </div>
      <div className='w-1/3'>
        <DesktopGuard data-sentry-element="DesktopGuard" data-sentry-source-file="DSearchHome.tsx">
          <UserBalances data-sentry-element="UserBalances" data-sentry-source-file="DSearchHome.tsx" />
          {/* TODO: Feedpeople also directly added in DesktopGuard during deposit flow refactor structure so we're only calling it once */}
          <FeedPeople className='h-[76vh]' data-sentry-element="FeedPeople" data-sentry-source-file="DSearchHome.tsx" />
        </DesktopGuard>
      </div>
    </div>
  );
};